import * as React from "react";
import get from "lodash/get";

import "./NextTier.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import { StoreState } from "../../reducers";

export interface NextTierProps extends ComponentBaseProps {
  onClick: () => void;
  action: string;
  successScreen: string;
  mode: string;
  content: string;
  rewardStats: StoreState["reward"]["rewardStats"];
}

export class NextTier extends ComponentBase<NextTierProps> {
  // tslint:disable:cyclomatic-complexity
  render() {
    const {
      style,
      classNames,
      rewardStats,
      action,
      successScreen,
      mode,
      isEditing,
    } = this.props;
    const isNextTier = get(rewardStats, "tierResult.isNextTier");
    const nextTier = get(rewardStats, "tierResult.nextTier");

    return (
      <div
        onDragStart={this.onDragStart}
        id={this.props.configName}
        onAnimationEnd={this.resetAnimation}
        style={{
          ...style,
          cursor: action || successScreen ? "pointer" : "inherit",
        }}
        className={`NextTier-text  NextTier-mode-${
          mode || "default"
        } ${classNames || ""} ${
          !isEditing ? "NextTier-text-preview" : ""
        } ${this.state.animationClass}`}
        aria-label={get(this.props, "label", "")}
        tabIndex={action ? 0 : undefined}
        ref={(component) => (this.component = component)}
      >
        {isNextTier ? nextTier : "-"}
      </div>
    );
  }
}
